// S10 Workflow editor (M11). Platform admins only. `?workflow=feature_request` edits the feature
// request workflow; anything else (or nothing) the bug workflow (poc CT-004).
import { WORKFLOW_CODES, type WorkflowCode } from '@feedback/shared/constants/workflow';
import { createFileRoute } from '@tanstack/react-router';
import { AdminLayout } from '@/features/admin/platform/AdminLayout';
import { WorkflowEditor } from '@/features/admin/workflow/WorkflowEditor';
import { requireStaffSession } from '@/lib/session';

interface WorkflowSearch {
  workflow?: typeof WORKFLOW_CODES.featureRequest;
}

export const Route = createFileRoute('/admin/workflow')({
  validateSearch: (search: Record<string, unknown>): WorkflowSearch =>
    search.workflow === WORKFLOW_CODES.featureRequest ? { workflow: WORKFLOW_CODES.featureRequest } : {},
  beforeLoad: ({ context, location }) => requireStaffSession(context.queryClient, location.href),
  component: WorkflowPage,
});

function WorkflowPage() {
  const { workflow } = Route.useSearch();
  const code: WorkflowCode = workflow ?? WORKFLOW_CODES.bug;
  return (
    <AdminLayout active="workflow">
      <WorkflowEditor workflow={code} />
    </AdminLayout>
  );
}
